import { GroupHeader } from "./messageHeader/commonHeader/GroupHeader";
import {
  CHAT_TYPE,
  IBroadcastInfo,
  IGroupInfo,
  IUserInfo,
} from "@home-health-notify/domain";
import { PrivateHeader } from "./messageHeader/privateChatHeader/PrivateHeader";
import { BroadcastHeader } from "./messageHeader/broadcastGroupHeader/BroadcastHeader";

interface ChatHeaderProps {
  chatType: CHAT_TYPE;
  info: IGroupInfo | IUserInfo | IBroadcastInfo;
  showSearch: boolean;
  setShowSearch: () => void;
  onFilter: (filters: any) => void;
  isMemberFlag: boolean;
  isChatLoading: boolean;
}

export const ChatHeader = ({
  chatType,
  info,
  showSearch,
  setShowSearch,
  onFilter,
  isMemberFlag,
  isChatLoading,
}: ChatHeaderProps) => {
  return (
    <>
      {chatType === CHAT_TYPE.GROUP && (
        <GroupHeader
          groupInfo={info as IGroupInfo}
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          onFilter={onFilter}
          isMemberFlag={isMemberFlag}
          isChatLoading={isChatLoading}
        />
      )}
      {chatType === CHAT_TYPE.PRIVATE && (
        <PrivateHeader
          userInfo={info as IUserInfo}
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          onFilter={onFilter}
          isChatLoading={isChatLoading}
        />
      )}
      {chatType === CHAT_TYPE.BROADCAST && (
        <BroadcastHeader
          broadcastInfo={info as IBroadcastInfo}
          isChatLoading={isChatLoading}
        />
      )}
    </>
  );
};
